document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.product-carousel-wrapper');

  wrappers.forEach(function (wrapper) {
    var track = wrapper.querySelector('.product-carousel-track');
    var prevBtn = wrapper.querySelector('.carousel-arrow-prev');
    var nextBtn = wrapper.querySelector('.carousel-arrow-next');
    if (!track) return;

    var slide = track.querySelector('.product-carousel-slide');
    var slideWidth = slide ? slide.getBoundingClientRect().width + 20 : 280;

    function scrollByAmount(amount) {
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByAmount(-slideWidth * 2);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByAmount(slideWidth * 2);
      });
    }

    // Autoplay
    var autoplay = wrapper.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed, 10) || 4000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplay) return;
      autoplayTimer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 5) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(slideWidth * 2);
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    startAutoplay();

    wrapper.addEventListener('mouseenter', stopAutoplay);
    wrapper.addEventListener('mouseleave', startAutoplay);
    wrapper.addEventListener('touchstart', stopAutoplay, { passive: true });

    // Recalculate slide width on resize
    window.addEventListener('resize', function () {
      var newSlide = track.querySelector('.product-carousel-slide');
      if (newSlide) {
        slideWidth = newSlide.getBoundingClientRect().width + 20;
      }
    });
  });
});